<template>
	<div class="home">
		<privacyComponent />
	</div>
</template>

<script>
import privacyComponent from "@/components/client/whousComponent.vue";
export default {
	name: "HomeView",
	components: {
		privacyComponent,
	},
};
</script>
